export default __webpack_public_path__ + "static/media/font.c833ec91.woff2";